import { App } from "@capacitor/app";
import { LiveUpdate } from "@capawesome/capacitor-live-update";
import { useEffect, useRef } from "react";
import { isNativePlatform } from "src/capacitor/appsHelpers";
import { useModals } from "src/components/Modals/context/ModalProvider";
import { ModalsNames } from "src/components/Modals/context/modals";

// Dopóki pobrany live update czeka na wgranie, proponuje aktualizację przy każdym wejściu do apki
export const LiveUpdateListener = () => {
	const { openModal } = useModals();
	// openModal zmienia się przy każdym renderze providera — listenery podpinamy raz
	const openModalRef = useRef(openModal);
	openModalRef.current = openModal;
	const isModalOpenRef = useRef(false);

	useEffect(() => {
		if (!isNativePlatform()) return;

		const showIfUpdatePending = async () => {
			if (isModalOpenRef.current) return;
			const [next, current] = await Promise.all([
				LiveUpdate.getNextBundle(),
				LiveUpdate.getCurrentBundle(),
			]);
			if (!next.bundleId || next.bundleId === current.bundleId) return;

			isModalOpenRef.current = true;
			openModalRef.current(ModalsNames.LiveUpdateReadyModal, {
				onHidden: () => {
					isModalOpenRef.current = false;
				},
			});
		};
		const check = () => showIfUpdatePending().catch(console.error);

		// Plugin sam sprawdza update przy powrocie z tła dopiero po 15 min od ostatniego sprawdzenia.
		// Wymuszamy sprawdzenie przy każdym powrocie; nowy bundle odpali nextBundleSet → modal.
		const syncAndCheck = async () => {
			const { syncing } = await LiveUpdate.isSyncing();
			if (!syncing) await LiveUpdate.sync();
			await showIfUpdatePending();
		};

		check();
		const listeners = [
			LiveUpdate.addListener("nextBundleSet", check),
			App.addListener("resume", () => {
				syncAndCheck().catch(console.error);
			}),
		];
		return () => {
			for (const listener of listeners) {
				listener.then((handle) => handle.remove());
			}
		};
	}, []);

	return null;
};
